import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How does delivery work?",
        a: "We hand-deliver your scooter fully charged to your hotel, vacation home, or cruise terminal. A quick walkthrough is included so you're comfortable using it. Pickup at the end of your rental is scheduled with you at booking.",
    },
    {
        q: "What areas do you serve?",
        a: "We deliver throughout Orlando, Kissimmee, and Port Canaveral. If your location is nearby but not listed, contact us — we usually can help.",
    },
    {
        q: "Can I bring the scooter to theme parks?",
        a: "Yes! The Pride Victory 10 is a great fit for theme parks and outdoor attractions. Please note that individual parks have their own accessibility policies.",
    },
    {
        q: "Can I take it on a cruise?",
        a: "Absolutely. We deliver directly to Port Canaveral. Include your cruise line and ship name in the booking notes and we'll coordinate the drop-off with a porter.",
    },
    {
        q: "What's the weight capacity?",
        a: "The Pride Victory 10 supports up to 400 lbs.",
    },
    {
        q: "What happens if I need help during my rental?",
        a: "Just call us. We'll do our best to support you with any issue and handle it promptly.",
    },
    {
        q: "What's your cancellation policy?",
        a: "Cancel up to 48 hours before delivery for a full refund. Within 48 hours, a partial credit is issued toward a future rental. Full details on our Rental Policies page.",
    },
    {
        q: "Is a deposit required?",
        a: "No separate deposit. You pay the total rental amount at checkout via secure Stripe payment.",
    },
];

export default function FAQ() {
    return (
        <div
            data-testid="faq-page"
            className="mx-auto max-w-4xl px-4 pb-24 pt-16 sm:px-6 lg:px-8"
        >
            <div className="text-xs font-semibold uppercase tracking-widest text-[color:var(--brand-green)]">
                FAQ
            </div>
            <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-[color:var(--brand-navy)] sm:text-5xl">
                Questions, answered
            </h1>
            <p className="mt-5 max-w-2xl text-slate-600">
                Everything you need to know about renting a scooter with Central
                Florida Mobility Rentals.
            </p>

            <div className="card-surface mt-12 p-2 sm:p-4">
                <Accordion type="single" collapsible className="w-full">
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="px-4 text-left text-base font-semibold text-[color:var(--brand-navy)] hover:no-underline">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="px-4 text-slate-600">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </div>
    );
}
